import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

// useEntitlement — single source of truth for "can this user access paid features?"
// Returns `entitlement` of 'active' | 'trial' | 'expired' (and 'loading' state).
// `refresh()` lets callers re-fetch after a purchase completes.
export default function useEntitlement() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/me/subscription");
      setData(res.data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/me/subscription");
        if (!cancelled) setData(res.data);
      } catch {
        if (!cancelled) setData(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const entitlement = data?.entitlement || "trial";
  return {
    entitlement,
    isActive: entitlement === "active",
    isTrial: entitlement === "trial",
    isExpired: entitlement === "expired",
    trialDaysRemaining: data?.trial_days_remaining,
    data,
    loading,
    refresh,
  };
}
